module.exports = __webpack_public_path__ + "img/tulique.893d9028.jpg";